import { ArrowLeft, Truck, PackageOpen, FileText } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import TablePagination from '../../components/atoms/Table/TablePagination'
import api from '../../config/AxiosInstance'
import '../../styles/style.css'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const Notification = () => {
  const navigate = useNavigate()
  const [notifications, setNotifications] = useState([])
  const [meta, setMeta] = useState({
    current_page: 1,
    per_page: 10,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    fetchNotifications(meta.current_page, meta.per_page)
  }, [meta.current_page, meta.per_page])

  const fetchNotifications = async (page, perPage) => {
    try {
      const res = await api.get(
        `/notifications/user?page=${page}&per_page=${perPage}`
      )
      if (res.data.success) {
        setNotifications(res.data.data)
        setMeta(res.data.metadata)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handlePageChange = (e) => {
    setMeta({ ...meta, current_page: e.selected + 1 })
  }

  const handleOnChangeMeta = (e) => {
    setMeta({ ...meta, per_page: e.target.value, current_page: 1 })
  }

  const splitDescription = (data) => {
    const words = data.description.split(' ')
    let link = ''
    if (data.type === 'sj') {
      link = `/outbound/sj/detail/${encodeURIComponent(
        words[words.length - 1]
      )}?notif_id=${data.id}`
    }
    if (data.type === 'outbound') {
      link = `/outbound/plan/detail/${data.outbound_id}?notif_id=${data.id}`
    }
    if (data.type === 'inbound') {
      link = `/inbound/purchase-receipt/${data.pr_id}`
    }
    return {
      description: words.slice(0, -1).join(' '),
      code: words[words.length - 1],
      link
    }
  }

  return (
    <Container>
      <Toaster />
      <Row>
        <Col className="d-flex align-items-center gap-3 mb-4">
          <h4>
            <ArrowLeft
              size={24}
              onClick={() => navigate('/dashboard')}
              style={{ cursor: 'pointer', color: 'grey' }}
            />
          </h4>
          <h4 style={headerTitleStyle}>Notifications</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="bg-white shadow-sm rounded-4 p-4">
            {notifications.length === 0 && (
              <div className="text-center p-5 text-muted">
                <i className="bi bi-bell-slash fs-2 mb-3"></i>
                <p className="fw-bold">No Notifications</p>
              </div>
            )}

            <div className="d-flex flex-column gap-3">
              {notifications.map((notification) => {
                const { description, code, link } =
                  splitDescription(notification)
                let IconComponent = PackageOpen
                let iconColor = '#f89d1d'
                let bgIcon = '#fff3e0'

                if (notification.type === 'outbound') {
                  IconComponent = Truck
                  iconColor = '#203568'
                  bgIcon = '#e8eaf6'
                } else if (notification.type === 'sj') {
                  IconComponent = FileText
                  iconColor = '#28a745'
                  bgIcon = '#e8f5e9'
                }

                return (
                  <div
                    key={notification.id}
                    className={`p-3 rounded-3 d-flex align-items-center gap-3 transition-hover ${
                      !notification?.is_read
                        ? 'bg-light border-start border-4 border-warning'
                        : 'bg-white border'
                    }`}
                    style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                    onClick={() => navigate(link)}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center rounded flex-shrink-0"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: bgIcon,
                        color: iconColor
                      }}
                    >
                      <IconComponent size={18} />
                    </div>

                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start mb-0">
                        <p
                          className="mb-0 text-dark"
                          style={{ fontSize: '13px' }}
                        >
                          {description}{' '}
                          <span className="fw-bold text-primary">{code}</span>
                        </p>
                        <span
                          className="text-secondary small ms-2 text-nowrap"
                          style={{ fontSize: '11px' }}
                        >
                          {notification.time}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            {notifications.length > 0 && (
              <TablePagination
                meta={meta}
                handleOnChangeMeta={handleOnChangeMeta}
                handlePageChange={handlePageChange}
              />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Notification
